import { render, staticRenderFns } from "./DicBeGoodAtNewList.vue?vue&type=template&id=08cf0cc8&scoped=true&"
import script from "./DicBeGoodAtNewList.vue?vue&type=script&lang=js&"
export * from "./DicBeGoodAtNewList.vue?vue&type=script&lang=js&"
import style0 from "./DicBeGoodAtNewList.vue?vue&type=style&index=0&id=08cf0cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf0cc8",
  null
  
)

export default component.exports